import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../../../FuncoesGerais/verificaApp';
import filtrarUsuarioIA from '../../../../FuncoesGerais/filtrarUsuarioIA';
import { ensureProtocol } from '../../../../config/backend';

import '../../styles/inventario.css';
import './Vinculacao.css';

function NovoVinculo(props) {

    const history = useHistory();

    const [data, setData] = useState([]);
    const [dataUsu, setDataUsu] = useState([]);

    const [selected, setSelected] = useState("");
    const [selectedUsu, setSelectedUsu] = useState("");

    const [obsVin, setObsVin] = useState('');

    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('N');
    const [sitVin, setSitVin] = useState('A');

    const pegarHardware = async (e) => {
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware/ativos/SemVinculo", {
                headers: {
                    Authorization: `${token}`
                }
            });
            const raw = Array.isArray(response.data) ? response.data : [];
            const listaHardware = raw.map((r) => ({
                codHar: r.CODHAR ?? r.codHar,
                serEqp: (r.SEREQP ?? r.serEqp ?? '').toString(),
                patEqp: (r.PATEQP ?? r.patEqp ?? '').toString(),
                nomEqp: (r.NOMEQP ?? r.nomEqp ?? '').toString()
            }));
            setData(listaHardware);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const pegarUsuarios = async (e) => {
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios/ativos", {
                headers: {
                    Authorization: `${token}`
                }
            });
            const raw = filtrarUsuarioIA(Array.isArray(response.data) ? response.data : [], 'USRNOMCPL');
            const listaNomes = raw.map((r) => ({
                nome: (r.USRNOMCPL ?? r.usrnomcpl ?? '').toString(),
                sequencia: r.USUSEQ ?? r.ususeq,
                USREML: r.USREML ?? r.usreml,
                USRLGN: r.USRLGN ?? r.usrlgn
            }));
            setDataUsu(listaNomes);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const verificarCampos = async () => {

        if (obsVin.trim() === '') {
            setMensagem("Atenção deve ser inserido a observação do vinculo!")
            return;
        }

        setMensagem("");
    };

    const inserindoHistorico = async () => {

        let codUsu = selectedUsu;

        let desHis = "Vinculo realizado com usuário:" + codUsu + "\n" + obsVin;

        let codHar = selected;

        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware",
                { codHar, desHis },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                });

        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }

    };

    const inserindoVinculo = async () => {

        verificarCampos();
        verificandoToken();

        const token = localStorage.getItem('token');

        let codEqp = selected;
        let codUsu = selectedUsu;

        try {

            await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/vinculacao",
                { codEqp, codUsu, obsVin, sitVin },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                });

            setMensagem('');
            setSucesso('S');

            inserindoHistorico();
        } catch (error) {
            setMensagem(error.response?.data?.error || 'Erro ao inserir/atualizar dados');
            setSucesso('N');
        }
    };

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };    

    useEffect(() => {

        verificar();
        pegarHardware();

        if (props.match.params.id) {
            setSelected(props.match.params.id);
        }

        pegarUsuarios();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo inventario-page">
            <div className="col-4">
                <h1>Realizar Vinculação</h1>
            </div>
            <form>
                
                <div className="col">
                    <label htmlFor="exampleInputEmail1">Hardware</label>
                    <select className="form-control disable" disabled={props.match.params.id} value={selected} onChange={(e) => { setSelected(e.target.value) }}>
                        <option value="">Selecione...</option>
                        {data.map((opt) => (
                            <option key={opt.codHar} value={opt.codHar}>
                                {opt.nomEqp + " - " + opt.serEqp + " - " + opt.patEqp}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col mt-2">
                    <label htmlFor="exampleInputEmail1">Usuário</label>
                    <select className="form-control disable" value={selectedUsu} onChange={(e) => { setSelectedUsu(e.target.value); }}>
                        <option value="">Selecione...</option>
                        {dataUsu.map((opt) => (
                            <option key={opt.sequencia} value={opt.sequencia}>
                                {opt.nome}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group mb-1 mt-2">
                    <label htmlFor="exampleInputEmail1">Observação da Vinculação</label>
                    <textarea type="email" className="form-control" rows={5} onChange={(e) => setObsVin(e.target.value)} value={obsVin} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Registrar Observação de Vinculação" />
                </div>

                <div className="form-row row mb-1">
                    <div className="form-group col">
                        <label htmlFor="inputEstado">Situação</label>
                        <select id="inputEstado" className="form-control" value={sitVin} onChange={(e) => { setSitVin(e.target.value) }} disabled>
                            <option value={"A"}>Ativo</option>
                        </select>
                    </div>
                </div>


                <button onClick={inserindoVinculo} type="button" className="btn btn-secondary btn-acao mt-4">Salvar</button>
                <Link to="/listaHardware" className="btn btn-outline-secondary btn-acao mt-4 ml-2">Voltar ao Inventário</Link>
            </form>

            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso === 'S' ? <Redirect to='/listaHardware' /> : null}
            </div>
            </main>
        </div>
    );
}

export default NovoVinculo;
